import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setSession } from '../api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { token, user } = await api.login(email.trim(), password);
      setSession(token, user);
      navigate(user.role === 'admin' ? '/admin/clients' : '/admin/skica');
    } catch (err) {
      setError(err.message || 'Gabim gjatë kyçjes.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={onSubmit}>
        <div className="login-ornament">✦</div>
        <h1>Kyçu</h1>
        <p className="login-subtitle">Paneli i Rregullimit të Ulëseve</p>

        <label>
          Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
        </label>
        <label>
          Fjalëkalimi
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>

        {error && <p className="login-error">{error}</p>}

        <button type="submit" disabled={loading}>{loading ? 'Duke u kyçur…' : 'Kyçu'}</button>
      </form>
    </div>
  );
}
